import { SharedElement } from 'components';
import { Instruction } from 'components/profile';
import { ProfileManager, Wrapper } from 'components/profile/selection-manager';
import { ProfileListPlain } from 'components/profile/selection-manager/profile-list/ProfileListPlain';
import { ProfileListSwiper } from 'components/profile/selection-manager/profile-list/ProfileListSwiper';
import { BlurBox, NeutralButton, RowLayout } from 'components/ui';
import { ItemList } from 'components/ui/swiper/ItemList';
import { SpatialNavSection } from 'context';
import { useProfileManager } from 'hooks';
import { useTranslation } from 'react-i18next';

export function ProfileManagerScreen() {
    const { t } = useTranslation();
    const { profiles, onProfileSelected, onBack, onAddProfile } =
        useProfileManager();

    return (
        <RowLayout alignItems="center" justifyContent="center" fullSize>
            <SharedElement id="box">
                <BlurBox>
                    <Wrapper count={profiles.length}>
                        <ProfileManager />
                        <Instruction>{t('profile.manage_profile')}</Instruction>
                        <RowLayout fullWidth>
                            <ItemList
                                ListSwiperComp={ProfileListSwiper}
                                ListPlainComp={ProfileListPlain}
                                list={profiles}
                                listItemSelected={onProfileSelected}
                            />
                        </RowLayout>
                        <SpatialNavSection>
                            <RowLayout>
                                <NeutralButton
                                    onClick={onBack}
                                    style={{
                                        marginRight: '1rem',
                                        minWidth: '230px',
                                    }}
                                >
                                    {t('buttons.back')}
                                </NeutralButton>
                                <NeutralButton
                                    onClick={onAddProfile}
                                    style={{
                                        minWidth: '230px',
                                    }}
                                >
                                    {t('buttons.add_profile')}
                                </NeutralButton>
                            </RowLayout>
                        </SpatialNavSection>
                    </Wrapper>
                </BlurBox>
            </SharedElement>
        </RowLayout>
    );
}
